import API from './API';
var DashboardService = {
    getStatus: function (config) {
        return API.get('/dashboard/status', config);
    }
};
export default DashboardService;
